// src/config.js

export const awsconfig = {
    // COGNITO AYARLARI (Giriş Sistemi)
    "aws_project_region": "eu-central-1",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_ZFlOstoch",         // KULLANICI HAVUZU ID'NİZ
    "aws_user_pools_web_client_id": "1r4laam011l2dgrj2kc51i06he", // APP CLIENT ID'NİZ

    // S3 DEPOLAMA AYARLARI (Resim Yükleme)
    "aws_user_files_s3_bucket": "gastronomi-kulubu-medya-bucket", // SİZİN S3 BUCKET ADINIZ
    "aws_user_files_s3_bucket_region": "eu-central-1" 
};

// API İSTEKLERİ İÇİN HALKA AÇIK ANAHTAR (Ana Site)
export const publicApiKey = 'Y6Do7oUzv87QwDVFFCthkyhXqun5OJN2ZUwLd5v0';